import {
  CreateUserRolePayload,
  UpdateUserRole,
} from "../interfaces/user-role.interface";
import axiosInstance from "../utils/axios-instance";

export const getUserRoleNames = async () => {
  const response = await axiosInstance.get(
    `${process.env.REACT_APP_API_BASE_URL}/cms/user-role/names`
  );
  return response.data;
};

export const createUserRole = async (data: CreateUserRolePayload) => {
  const response = await axiosInstance.post(
    `${process.env.REACT_APP_API_BASE_URL}/cms/user-role`,
    data
  );
  return response.data;
};

export const listUserRoles = async () => {
  const response = await axiosInstance.get(
    `${process.env.REACT_APP_API_BASE_URL}/cms/user-role/list`
  );
  return response.data;
};

export const archiveUserRole = async (data: { roleName: string }) => {
  const response = await axiosInstance.post(
    `${process.env.REACT_APP_API_BASE_URL}/cms/user-role/delete`,
    data
  );
  return response.data;
};

export const updateUserRole = async (data: UpdateUserRole) => {
  const response = await axiosInstance.put(
    `${process.env.REACT_APP_API_BASE_URL}/cms/user-role`,
    data
  );
  return response.data;
};

export const getUserRole = async (data: { roleName: string }) => {
  const response = await axiosInstance.get(
    `${process.env.REACT_APP_API_BASE_URL}/cms/user-role?roleName=${data.roleName}`
  );
  return response.data;
};
